export type StandardPrice = {
	amount: number,
	currencyCode: string,
}

function render( standardPrice?: StandardPrice ) {
	return standardPrice?.amount ? new Intl.NumberFormat( 'en-US', {
		style: 'currency',
		currency: standardPrice?.currencyCode ?? 'USD',
		maximumFractionDigits: 4,
		minimumFractionDigits: 2,
	} ).format( standardPrice.amount ) : ''
}

export default {
	field: 'part.standardPrice',
	name: 'List Price',
	width: '120px',
	align: 'right',
	render,
}
